import { useState, useEffect, useCallback } from "react";
import { requestsApi } from "../../api/api";
import { REQUEST_STATUS } from "../../constants/constants";

export const useActive = (icaoLocationIndicator, searchTerms = "") => {
  const normalizedSearchTerms = searchTerms.trim();
  const [data, setData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  const fetchData = useCallback(async () => {
    if (!icaoLocationIndicator) return;
    setIsFetching(true);
    try {
      const response = await requestsApi.getByAts(icaoLocationIndicator, REQUEST_STATUS.ACTIVE, normalizedSearchTerms);
      setData(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsFetching(false);
    }
  }, [icaoLocationIndicator, normalizedSearchTerms]);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, [fetchData]);

  return { data, isFetching, refetch: fetchData };
};
